import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { BetSlipStatusAbrv } from "@utils";

export default function BetItemPayment() {
	const { t } = useTranslation("mybets");

	const bet = useContext(MyBetsBetContext);

	if (
		bet.betStatus?.abrv == BetSlipStatusAbrv.WON &&
		(bet.betSlipStatus.abrv == BetSlipStatusAbrv.PAID_OUT ||
			bet.betSlipStatus.abrv == BetSlipStatusAbrv.CASHOUT)
	) {
		return (
			<th className="table--bets__th table--bets__th--price">
				<span>{t<string>("ITEM.PAYOUT")}:</span>

				<span>{bet.displayPayout}</span>
			</th>
		);
	}

	return (
		<th className="table--bets__th table--bets__th--price">
			<span>{t<string>("ITEM.INFO_MAX_GAIN")}:</span>

			<span className="u-type--wgt--bold">{bet.displayMaxGain}</span>
		</th>
	);
}
